// extracted by mini-css-extract-plugin
export default {"preloaderContent":"main_preloaderContent__FHtIr","app":"main_app__jdRZv"};